// @core/api/endpoints/form/update_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormResponse,
  UpdateFormRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Update form
 * Updates form properties such as name, description, settings, and pages.
 */
export async function UpdateForm(
  form_id: string,
  data: UpdateFormRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.put<FormResponse>(requestPath, data, requestOptions);
}
